import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import { injectIntl } from 'react-intl';

import { emptyObject } from 'ui-components/default-props/empty';
import {
  exportOrdersRequest,
  customExportOrdersRequest,
  openExportOrdersModal,
} from '../../../../store/export/orders/export-orders.actions';
import { ExportOptions } from '../enums/export-options-enum';
import { DefaultExportFormat } from '../enums/default-export-format';
import Global from '../../../../store/global-selectors';
import { ExportRecordsContainer } from './export-records-container';
import { useQuickSearchTerm } from '../../../../hooks/routing/use-quick-search-term';
import { useIsOnOrdersAdvancedSearchView } from '../../../../advanced-search/hooks';

const ExportOrdersModalWrapper = ({ modalFrameworkMethods, filters = emptyObject, intl }) => {
  const [orderExportType, setOrderExportType] = useState(ExportOptions.ORDER);
  const selectedOrderIds = useSelector((state) => Global.selectSelectedOrdersIds(state));
  const numberRecordsSelected = selectedOrderIds.length;
  const numberRecordsInView = useSelector((state) => Global.selectOrdersGridTotalRecords(state));
  const recordExportType = ExportOptions.ORDER_RECORD_EXPORT;
  const dispatch = useDispatch();
  const { closeModal } = modalFrameworkMethods;
  const searchTerm = useQuickSearchTerm();
  const isOnAdvancedSearch = useIsOnOrdersAdvancedSearchView();

  const onInitiateExport = useCallback(
    (viewRecordsOrSelectedRecords, primaryRecordsOrLineItems, selectedExportFormatTypeId) => {
      if (selectedExportFormatTypeId === DefaultExportFormat.extractId) {
        dispatch(
          exportOrdersRequest(viewRecordsOrSelectedRecords, primaryRecordsOrLineItems, searchTerm, filters, isOnAdvancedSearch, intl),
        );
        closeModal();
        return;
      }

      dispatch(
        customExportOrdersRequest(
          viewRecordsOrSelectedRecords,
          selectedExportFormatTypeId,
          selectedOrderIds,
          searchTerm,
          filters,
          isOnAdvancedSearch,
          intl,
        ),
      );
      closeModal();
    },
    [dispatch, selectedOrderIds, searchTerm, filters, isOnAdvancedSearch, intl, closeModal],
  );

  const updateOrderExportType = useCallback(
    (primaryRecordsOrLineItems) => {
      if (primaryRecordsOrLineItems === ExportOptions.EXPORT_PRIMARY_RECORDS) {
        setOrderExportType(ExportOptions.ORDER);
        return;
      }
      setOrderExportType(ExportOptions.ORDER_LINE_ITEM);
    },
    [setOrderExportType],
  );

  return (
    <ExportRecordsContainer
      exportTypeEnum={orderExportType}
      modalFrameworkMethods={modalFrameworkMethods}
      numberRecordsInView={numberRecordsInView}
      numberRecordsSelected={numberRecordsSelected}
      onInitiateExport={onInitiateExport}
      onUpdateExportType={updateOrderExportType}
      recordExportType={recordExportType}
      retryAction={openExportOrdersModal}
    />
  );
};

ExportOrdersModalWrapper.propTypes = {
  modalFrameworkMethods: PropTypes.object.isRequired,
  filters: PropTypes.object,
  intl: PropTypes.object.isRequired,
};

export const ExportOrdersContainer = injectIntl(ExportOrdersModalWrapper);
